import React from "react";
import { EntityProfileIndustry } from "@common/types/entity";
import { noop } from "@common/helpers/function";
import {
    FilterMultiselect,
    FilterMultiselectOption,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { industryLabels } from "@components/entity/constants";
import { BaseFilterProps } from "../../lib";
import styles from "./EntityIndustryFilter.module.scss";

const industries = Object.values(EntityProfileIndustry);

const industriesSet: ReadonlySet<string> = new Set(industries);

const options: FilterMultiselectOption[] = industries.map((v) => ({
    value: v,
    label: industryLabels[v],
    searchableLabel: industryLabels[v],
}));

export const EntityIndustryFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const value = filters.entityIndustries ?? [];

    return (
        <div className={styles.filter}>
            <FilterMultiselect
                maxListHeight={340}
                inDropdown={false}
                options={options}
                value={value}
                onChange={(val) => {
                    const filtered = val.filter(
                        (v): v is EntityProfileIndustry =>
                            industriesSet.has(String(v)),
                    );
                    onChange({
                        entityIndustries:
                            filtered.length > 0 ? filtered : undefined,
                    });
                }}
                name="entityIndustries"
                onBlur={noop}
            />
        </div>
    );
};
